import React, { useState, useEffect, useRef, useMemo, useCallback, useContext, } from "react";
var HIDE_DELAY = 500;
var REFRESH_INTERVAL = 120;
var OverPageLoadingBarContext = React.createContext(null);
export var OverPageLoadingBarProvider = function (_a) {
    var children = _a.children;
    var _b = useState(0), isLoadingCounter = _b[0], setIsLoadingCounter = _b[1];
    var setIsLoading = useCallback(function (isLoading) {
        if (isLoading) {
            setIsLoadingCounter(isLoadingCounter + 1);
        }
        else {
            setIsLoadingCounter(Math.max(isLoadingCounter - 1, 0));
        }
    }, [isLoadingCounter, setIsLoadingCounter]);
    var isLoading = useMemo(function () { return isLoadingCounter !== 0; }, [isLoadingCounter]);
    return (React.createElement(OverPageLoadingBarContext.Provider, { value: [isLoading, setIsLoading] }, children));
};
export var useSetOverPageLoadingBarState = function () {
    var state = useContext(OverPageLoadingBarContext);
    if (!state) {
        throw new Error("OverPageLoadingBarContext.Provider not found");
    }
    var setLoading = state[1];
    return setLoading;
};
export var LoadingBar = function (_a) {
    var _b = _a.speed, speed = _b === void 0 ? 0.9 : _b, isLoading = _a.isLoading, _c = _a.overPage, overPage = _c === void 0 ? false : _c, _d = _a.presetPercent, presetPercent = _d === void 0 ? 0 : _d;
    var _e = useState(presetPercent), percent = _e[0], setPercent = _e[1];
    var _f = useState(false), shouldLoad = _f[0], setShouldLoad = _f[1];
    var intervalRef = useRef(null);
    useEffect(function () {
        if (shouldLoad) {
            intervalRef.current = setInterval(function () {
                if (percent < 99) {
                    setPercent(percent + 1);
                }
            }, REFRESH_INTERVAL);
        }
        return function () {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [setPercent, shouldLoad, percent]);
    var stop = useCallback(function () {
        setShouldLoad(false);
        setPercent(100);
        var timeout = setTimeout(function () {
            setPercent(0);
        }, HIDE_DELAY);
        return function () { return clearInterval(timeout); };
    }, [setPercent, setShouldLoad]);
    useEffect(function () {
        if (isLoading) {
            setShouldLoad(true);
        }
        else if (shouldLoad) {
            stop();
        }
    }, [stop, isLoading, shouldLoad, setShouldLoad]);
    var containerStyle = useMemo(function () { return ({
        opacity: percent < 100 ? 1 : 0,
        WebkitTransition: "".concat(speed, "s opacity"),
        transition: "".concat(speed, "s opacity"),
        WebkitTransitionDelay: "".concat(percent < 100 ? 0 : HIDE_DELAY, "s"),
        transitionDelay: "".concat(percent < 100 ? 0 : HIDE_DELAY, "s"),
    }); }, [percent, speed]);
    var barStyle = useMemo(function () { return ({
        width: "".concat(percent, "%"),
        WebkitTransition: "".concat(speed, "s width, ").concat(speed, "s background-color"),
        transition: "".concat(speed, "s width, ").concat(speed, "s background-color"),
    }); }, [percent, speed]);
    return (React.createElement("div", { className: "LoadingBar-container ".concat(overPage ? "LoadingBar-container-overpage" : ""), style: containerStyle },
        React.createElement("div", { className: "LoadingBar-bar ".concat(percent === 0 ? "LoadingBar-bar-fading" : "", " ").concat(overPage ? "LoadingBar-bar-overpage" : ""), style: barStyle })));
};
export var OverPageLoadingBar = function (_a) {
    var _b = _a.speed, speed = _b === void 0 ? 0.9 : _b;
    var state = useContext(OverPageLoadingBarContext);
    if (!state) {
        throw new Error("AlertContext.Provider not found");
    }
    var isLoading = state[0];
    return React.createElement(LoadingBar, { isLoading: isLoading, speed: speed, overPage: true });
};
